import React from "react";
import { VipPayment } from "../../components/datatable/vipPaymentData";

const VipPayed = () => {
  return <VipPayment />;
};

export default VipPayed;
